import { AxiosResponse } from 'axios';
import apiClient from '../axios';
import { Product, IGetProductListResponse } from './interfaces';

export const getProductList = async (): Promise<Product[]> => {
  const response: AxiosResponse<IGetProductListResponse> = await apiClient.get(
    '/products/list'
  );

  return response.data.data;
};

export const getClientProductList = async (
  clientId: number
): Promise<Product[]> => {
  const response: AxiosResponse<IGetProductListResponse> = await apiClient.get(
    `/clients/${clientId}/products/list`
  );

  return response.data.data;
};
